"use client";

import { Comment } from "./CommentSection";
import { CommentAuthorComedian } from "@punchup/data/models";
import CommentItem from "./CommentItem";
import { buildUserMap } from "./utils/mentionUtils";

interface CommentListProps {
  comments: Comment[];
  currentUserId?: string;
  currentUser?: any; // Full user object for ModernCommentInput
  onReply?: (
    content: string,
    parentId: string,
    replyingToUsername?: string,
    authorComedian?: CommentAuthorComedian | null
  ) => void;
  onClap?: (commentId: string, clapCount: number) => Promise<void>;
  onEdit?: (commentId: string, newContent: string) => void;
  onDelete?: (commentId: string) => void;
  // Optional tracking context
  specialId?: string;
  comedianId?: string;
  isLoggedIn?: boolean;
  userFollowsComedian?: boolean;
}

export default function CommentList({
  comments,
  currentUserId,
  currentUser,
  onReply,
  onClap,
  onEdit,
  onDelete,
  specialId,
  comedianId,
  isLoggedIn,
  userFollowsComedian,
}: CommentListProps) {
  // Build user map for @mention functionality
  const availableUsers = buildUserMap(comments);

  return (
    <div className="space-y-4" data-testid="comment-list">
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          currentUserId={currentUserId}
          currentUser={currentUser}
          onReply={onReply}
          onClap={onClap}
          onEdit={onEdit}
          onDelete={onDelete}
          availableUsers={availableUsers}
          specialId={specialId}
          comedianId={comedianId}
          isLoggedIn={isLoggedIn}
          userFollowsComedian={userFollowsComedian}
        />
      ))}
    </div>
  );
}
